define('models/CurrencyModel',['underscore','ObjectModel','LocalStorage','app'],function (_,ObjectModel,LocalStorage,app) {
    //
    // Model Currency
    //
    var CurrencyModelPrototype = {
        
        name:'CurrencyModel',
        idAttribute:'id_currency',
        
        initialize:function(){
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this,arguments);
            //
        },
        modernizr:function(){
            var sign = this.getSign();
            Modernizr.addTest('currency-sign-small', function () {
                return sign.length<2;
            });
        },
        getSign:function(){
            var model = this,
                s = model.get('s');
            if(!s){
                // on cache le signe
                s = model.get('sign');
                if(!_.isString(s)){
                    s = app.c('_SIGN_CURRENCY_DEFAULT_','?');
                }
                model.set('s',s);
            }
            return s;
        },
        getIsoCode:function(){
            return this.get('iso_code');
        },
        getDecimals:function(){
            var model = this,
                d = model.get('d');
            if(!d){
                // on calcule et on cache la valeur numérique des décimales
                d = parseInt(this.get('decimals'));
                if(_.isNaN(d)){
                    d = parseInt(app.c('_PRICE_DISPLAY_PRECISION_',2)); // valeur par défaut, 2 décimales
                }
                model.set('d',d);
            }
            return d;

        }
    };

    var CurrencyModel = ObjectModel.extend(LocalStorage).extend(CurrencyModelPrototype);
    
    return CurrencyModel;
});
